import React, { useMemo } from "react";

import { HookSelectFormGroup } from "components";
import { FormColumn, FormRow } from "components/layout";
import { DebounceTimeout } from "globalConstants";
import { PaymentTypes } from "types";
import { required } from "validators";

import { paymentTypeFieldName } from "./paymentMethodConstants";

export const PaymentTypeFields = ({ isLoading }) => {
	const paymentTypesOptions = useMemo(() => {
		const options = [PaymentTypes.ach];
		return options;
	}, []);

	return (
		<FormRow>
			<FormColumn>
				<HookSelectFormGroup
					label="Payment Type"
					options={paymentTypesOptions}
					getOptionLabel={option => option.displayName}
					getOptionValue={option => option.value}
					placeholder="Please Select"
					name={paymentTypeFieldName}
					isSearchable={false}
					cacheOptions
					defaultOptions
					debounceTimeout={DebounceTimeout}
					blurLoading={isLoading}
					rules={{
						validate: {
							required,
						},
					}}
					showRequiredMark
				/>
			</FormColumn>
		</FormRow>
	);
};
